import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "leftHandle", "rightHandle", "progress", "leftLabel", "rightLabel", "leftTooltip", "rightTooltip"]
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    valueMin: { type: Number, default: 0 },
    valueMax: { type: Number, default: 100 }
  }

  connect() {
    this.isDragging = false
    this.currentHandle = null
    this.updateUI()
  }

  startDragLeft(event) {
    this.startDrag(event, 'left')
  }

  startDragRight(event) {
    this.startDrag(event, 'right')
  }

  startDrag(event, handle) {
    // Prevent text selection but allow focus
    if (event.type === 'mousedown') {
      event.preventDefault()
    }

    this.isDragging = true
    this.currentHandle = handle

    // Keep focus on the handle
    const handleElement = handle === 'left' ? this.leftHandleTarget : this.rightHandleTarget
    handleElement.focus()

    this.boundDrag = this.drag.bind(this)
    this.boundStopDrag = this.stopDrag.bind(this)

    document.addEventListener('mousemove', this.boundDrag)
    document.addEventListener('mouseup', this.boundStopDrag)
    document.addEventListener('touchmove', this.boundDrag, { passive: false })
    document.addEventListener('touchend', this.boundStopDrag)
  }

  drag(event) {
    if (!this.isDragging) return

    const rect = this.trackTarget.getBoundingClientRect()
    const clientX = event.touches ? event.touches[0].clientX : event.clientX
    const x = clientX - rect.left
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100))
    const value = this.minValue + (percentage / 100) * (this.maxValue - this.minValue)

    if (this.currentHandle === 'left') {
      this.valueMinValue = Math.min(value, this.valueMaxValue)
    } else {
      this.valueMaxValue = Math.max(value, this.valueMinValue)
    }

    this.updateUI()
  }

  stopDrag() {
    this.isDragging = false
    this.currentHandle = null

    if (this.boundDrag && this.boundStopDrag) {
      document.removeEventListener('mousemove', this.boundDrag)
      document.removeEventListener('mouseup', this.boundStopDrag)
      document.removeEventListener('touchmove', this.boundDrag)
      document.removeEventListener('touchend', this.boundStopDrag)
    }
  }

  updateUI() {
    const leftPercent = ((this.valueMinValue - this.minValue) / (this.maxValue - this.minValue)) * 100
    const rightPercent = ((this.valueMaxValue - this.minValue) / (this.maxValue - this.minValue)) * 100

    // Update handles
    this.leftHandleTarget.style.left = `calc(${leftPercent}% - 12px)`
    this.rightHandleTarget.style.left = `calc(${rightPercent}% - 12px)`

    // Update progress bar
    this.progressTarget.style.left = `${leftPercent}%`
    this.progressTarget.style.width = `${rightPercent - leftPercent}%`

    // Update labels if present
    if (this.hasLeftLabelTarget) {
      this.leftLabelTarget.style.left = `${leftPercent}%`
      this.leftLabelTarget.textContent = `${Math.round(leftPercent)}%`
    }

    if (this.hasRightLabelTarget) {
      this.rightLabelTarget.style.left = `${rightPercent}%`
      this.rightLabelTarget.textContent = `${Math.round(rightPercent)}%`
    }

    // Update tooltips if present
    if (this.hasLeftTooltipTarget) {
      this.leftTooltipTarget.querySelector('span').textContent = `${Math.round(leftPercent)}%`
    }

    if (this.hasRightTooltipTarget) {
      this.rightTooltipTarget.querySelector('span').textContent = `${Math.round(rightPercent)}%`
    }
  }
}
